import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import {
  Wrapper,
  HeadlineWrapper,
  Headline,
  EditIconWrapper,
  EditIcon,
  AdditionalItemDivider,
  DataWrapper,
  DataRow,
  DataRowHeader,
  DataRowContent,
} from './AdditionalListContentUI';

export interface AdditionalOperationContentProps {
  customerId: string;
  operationId: string;
}

export const AdditionalOperationContent: FC<AdditionalOperationContentProps> = (props) => {
  const { customerId, operationId } = props;

  return (
    <Wrapper>
      <HeadlineWrapper>
        <Headline>Unternehmensdaten</Headline>
        <EditIconWrapper>
          <Link to={`/customers/${customerId}`}>
            <EditIcon icon={'edit'} size={22} />
          </Link>
        </EditIconWrapper>
      </HeadlineWrapper>
      <AdditionalItemDivider />
      <DataWrapper>
        <DataRow>
          <DataRowHeader>Gesprächsprotokoll</DataRowHeader>
          <DataRowContent>
            <EditIconWrapper>
              <Link to={`/customers/${customerId}/operations/${operationId}`}>
                <EditIcon icon={'edit'} size={20} />
              </Link>
            </EditIconWrapper>
          </DataRowContent>
        </DataRow>
      </DataWrapper>
    </Wrapper>
  );
};
